import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { environment } from 'src/environments/environment';
import { ModalFeedbackReportComponent } from '../../modals/modal-feedback-report/modal-feedback-report.component';

@Component({
  selector: 'app-feedback-report-button',
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule, TranslateModule],
  templateUrl: './feedback-report-button.component.html',
  styleUrls: ['./feedback-report-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackReportButtonComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  showButton = false;
  /** True when the app footer intersects the viewport (user can see it or is near it). */
  footerInView = true;
  private subscription?: Subscription;
  private footerObserver?: IntersectionObserver;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        this.showButton =
          !!environment.feedbackGloballyEnabled || !!data['feedbackEnabled'];
        this.cdr.markForCheck();
      });

    // Check initial route
    let route = this.activatedRoute;
    while (route.firstChild) route = route.firstChild;
    this.showButton =
      !!environment.feedbackGloballyEnabled ||
      !!route.snapshot.data['feedbackEnabled'];
    this.cdr.markForCheck();
  }

  ngAfterViewInit(): void {
    const footer = document.querySelector('app-footer');
    if (!footer || typeof IntersectionObserver === 'undefined') {
      return;
    }

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        if (!e) return;
        const next = e.isIntersecting;
        if (next !== this.footerInView) {
          this.footerInView = next;
          this.cdr.markForCheck();
        }
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );
    this.footerObserver.observe(footer);
  }

  ngOnDestroy(): void {
    this.footerObserver?.disconnect();
    this.subscription?.unsubscribe();
  }

  openModal(): void {
    this.dialog.open(ModalFeedbackReportComponent, {
      panelClass: 'medium-dialog',
      width: '500px',
      data: {},
    });
  }
}
